import React, {Component} from "react";
import {Form, Modal , Radio,Row,Col} from 'antd';
import NHFetch from "../../../utils/NHFetch";
import Viewer from 'react-viewer';

const FormItem = Form.Item;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            previewVisible: false,
            blyy:'',
            fj:[],
        }
    }
    componentWillMount(){
        //根据lstdid 获取办理原因
        let initFormData = this.props.initFormData;
        NHFetch(`/swbl/lstd/lstdblyy/${initFormData.PKID}/getBlyyStr`,"get").then(res=>{
            if(res){
                this.setState({blyy:res.data});
            }
        })

        NHFetch(`/swbl/lstd/${initFormData.PKID}/getFjList`,"get").then(res=>{
            if(res){
                this.setState({fj:res.data});
            }
        })

    }

     //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
     setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }
    // (这个地方包含处理审核和新增的图片预览逻辑。)点击文件链接或预览图标时的回调
    handlePreview = (fj, fjid) => {
        let isImage = true;
        const name = fj.name || fj.fjmc;
        fjid = fjid || fj.response.data.ssbh
        if (
            !this.setJudge(name, this.state.judgeImgList)
        ) {
            isImage = false;
        }

        if (isImage) {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }
    // 关闭图片弹窗
    handleCancel = () => this.setState({ previewVisible: false });


    render() {
        const initFormData = this.props.initFormData;
        console.log(initFormData.XM)
        console.log(initFormData.XH)
        return (
            <div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}> 姓名(学号)：</Col>
                    <Col span={8}>{initFormData.XM?(initFormData.XH?`${initFormData.XM}(${initFormData.XH})`:`${initFormData.XM}`):''}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>身份证号：</Col>
                    <Col span={8}>{initFormData.SFZJH}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>办理金额：</Col>
                    <Col span={8}>{initFormData.BLJE}元</Col>
                    <Col span={4} style={{textAlign:'right'}}>办理时间：</Col>
                    <Col span={8}>{initFormData.BLSJ}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>办理原因：</Col>
                    <Col span={20}>{this.state.blyy}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>贷款银行：</Col>
                    <Col span={8}>{initFormData.DKYHMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>6位数回执校验码：</Col>
                    <Col span={8}>{initFormData.HZJYM}</Col>
                </Row>
                <Row gutter={24}>
                    <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                        style={{color: 'rgba(0, 0, 0, 0.85)'}}>材料证明&nbsp;: </span></Col>
                    <Col span={20}>
                        {this.state.fj.map((elem, index) => {
                            return (
                                <div style={{marginBottom: '20px'}}>
                                    <a onClick={() => {
                                        this.handlePreview(elem, elem['fjid']);
                                    }}>{elem['fjmc']}</a>
                                </div>
                            )
                        })
                        }
                    </Col>
                </Row>
                {initFormData.SJLY=='2' && <div>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZTMC}</Col>
                        <Col span={4} style={{textAlign:'right'}}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                    </Row>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                    </Row>
                </div>}
                <Viewer
                        visible={this.state.previewVisible}
                        onClose={this.handleCancel}
                        images={[{ src:this.state.previewImage, alt: '' }]}
                    />
                {/* <Modal
                    visible={this.state.previewVisible}
                    footer={null}
                    onCancel={this.handleCancel}
                >
                    <img
                        alt="example"
                        style={{ width: '100%' }}
                        src={this.state.previewImage}
                    />
                </Modal> */}
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/lstd/ViewForm.js